import type {EnvironmentOptions} from './request'

const environment: EnvironmentOptions = {
  middleware: [],
}

export default environment
